module.exports = __webpack_public_path__ + "img/pic_watch@2x.7adf28bf.png";